export default __webpack_public_path__ + "static/media/desk08.c45e55f1.jpg";